<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <div class="body">
      <h1 class="t-inverse t-center">
        Account Verified!
      </h1>

      <p class="t-inverse t-center">
        Thank you for verifying your email address.
      </p>

      <div class="t-center">
        <router-link class="button button--inverse" to="/wizard">Search Properties</router-link>
      </div>
    </div>
  </layout-fullscreen>
</template>

<script>
  import { mapActions } from 'vuex';
  import { backend } from '@/api';
  import LayoutFullscreen from '@/layouts/Fullscreen';

  export default {
    name: 'AccountVerify',

    props: {
      token: {
        type: String,
        required: true
      }
    },

    components: {
      LayoutFullscreen
    },

    methods: {
      ...mapActions([
        'setUser'
      ])
    },

    async created () {
      this.$store.commit('updateLoading', true);

      await backend.auth.email.verify(encodeURIComponent(this.token))
        .then(({ data }) => this.setUser(data))
        .catch(({ response }) => console.log(response))

      this.$store.commit('updateLoading', false)
    }
  };
</script>